import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { userAtom } from '@root/entities/auth'

import { HeaderBrand } from './header-brand'
import { HeaderGuest } from './header-guest'
import { HeaderUser } from './header-user'

export const Header: React.FC = () => {
  const [isLoggedIn] = useAtom((ctx) => !!ctx.spy(userAtom))

  const HeaderContent = isLoggedIn ? HeaderUser : HeaderGuest

  return (
    <Root>
      <HeaderBrand />
      <End>
        <HeaderContent />
      </End>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  padding-inline: 12px;
  align-items: center;
  height: 48px;
  gap: 8px;

  background-color: var(--background-1);
  border-bottom: 1px solid var(--background-2);
`

const End = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
  justify-content: end;
  justify-items: end;
  align-items: center;
`
